module.exports = __webpack_public_path__ + "static/media/rafael.9ad0e486.jpg";